import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft, Play, Loader2 } from 'lucide-react';
import { useMeditations, useMeditationCategories } from '@/hooks/useMeditations';
import { useTelegram } from '@/hooks/useTelegram';

export function RelaxCategory() {
  const { slug } = useParams<{ slug: string }>();
  const nav = useNavigate();
  const { haptic } = useTelegram();
  const { meditations, loading } = useMeditations(slug);
  const { categories } = useMeditationCategories();
  
  const category = categories.find((c) => c.slug === slug);

  function openPlayer(meditationSlug: string) {
    haptic('light');
    nav(`/relax/player/${meditationSlug}`);
  }

  return (
    <div className="flex flex-col h-[100dvh] max-w-md mx-auto pb-20">
      {/* Header */}
      <div className="px-5 pt-4 pb-3 flex items-center gap-3 border-b border-line/50">
        <button
          onClick={() => nav(-1)}
          className="w-8 h-8 rounded-full bg-bg-elevated flex items-center justify-center"
        >
          <ChevronLeft size={18} className="text-ink-muted" />
        </button>
        <div className="flex-1">
          <div className="font-display font-bold text-base leading-tight">
            {category?.emoji} {category?.title || 'Категория'}
          </div>
          {category?.subtitle && (
            <div className="text-[10px] text-ink-dim">{category.subtitle}</div>
          )}
        </div>
      </div>

      {/* Список треков */}
      <div className="flex-1 overflow-y-auto px-5 py-4 space-y-2">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="w-5 h-5 animate-spin text-emerald-glow" />
          </div>
        ) : meditations.length === 0 ? (
          <div className="text-center py-8 text-ink-dim text-sm">
            В этой категории пока нет треков
          </div>
        ) : (
          meditations.map((m) => (
            <button
              key={m.id}
              onClick={() => openPlayer(m.slug)}
              className="w-full bg-bg-card border border-line rounded-xl p-3 flex items-center gap-3 active:scale-[0.99] transition-all"
            >
              <div className="text-2xl shrink-0">{m.emoji || '🎵'}</div>
              <div className="flex-1 text-left min-w-0">
                <div className="text-sm font-medium">{m.title}</div>
                {m.subtitle && (
                  <div className="text-[11px] text-ink-muted truncate mt-0.5">
                    {m.subtitle}
                  </div>
                )}
                {m.description && (
                  <div className="text-[10px] text-ink-dim line-clamp-2 mt-1 leading-relaxed">
                    {m.description}
                  </div>
                )}
              </div>
              <div className="w-9 h-9 rounded-full bg-emerald-glow/20 text-emerald-glow flex items-center justify-center shrink-0">
                <Play size={14} className="fill-current ml-0.5" />
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
